export const userRoutes = {
	users: (query: string) => `/accounts/${query ? `?${query}` : ''}`,
	userHistory: (id: string) => `/accounts/${id}/history/`,
	user: (id: string) => `/accounts/${id}/`
} as const
